import {STATIC_TEXT_CONSTS} from "../constants";

export const initialState = {
    staticTextsList: {},
    priceFormattingRegExp: /\B(?=(\d{3})+(?!\d))/g,
};

export default (state = initialState, action) => {
    // console.log(action.payload);
    switch (action.type) {
        case STATIC_TEXT_CONSTS.GET_STATIC_TEXTS:
            return {
                staticTextsList: action.payload,
                priceFormattingRegExp: /\B(?=(\d{3})+(?!\d))/g,
            };
        case STATIC_TEXT_CONSTS.UPDATE_STATIC_TEXTS:
            const changeLanguage = state.staticTextsList[action.payload.code];
            return {
                staticTextsList: {
                    ...state.staticTextsList,
                    [action.payload.code]: {
                        ...changeLanguage,
                        [action.payload.key]: action.payload.value
                    }
                }
            };
        default:
            return state;
    }
}
